module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-contaier"
  }, [(_vm.loaded) ? _c('div', {
    staticClass: "waiting-revenue"
  }, [_c('div', {
    staticClass: "number-container"
  }, [_c('h2', [_c('span', {
    staticClass: "currency"
  }, [_vm._v(_vm._s(_vm.currencySymbol))]), _vm._v(" " + _vm._s(_vm.number.toLocaleString(_vm.currencyCode)))])])]) : _c('div', {
    staticClass: "loading"
  }, [_c('i', {
    staticClass: "el-icon-loading"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-558299a5","hasScoped":false}!./src/app/components/widgets/revenue/revenue.html
// module id = 3014
// module chunks = 1